import { CheckListValueModel, PaymentInfo } from "../../../models/ApplicationModel";
import { ApplicantType, Assignee, Country } from "../../../models/CommonModels";
import { UserDto } from "../../../models/User";
import { ChecklistModel } from '../../../models/ChecklistModel';
import { DocumentDetail } from "../../../models/ApplicationDetail";

export class InspectionStatus {
    id: number;
    name: string;
    inspectionStatusCode: string;
}

export class InspectionType {
    id: number;
    name: string;
    inspectionTypeCode: string;
}

export class InvestigationType {
    id: number;
    name: string;
    investigationTypeCode: string;
}

export class InspectionReason {
    id: number;
    name: string;
    reasonCode: string;
}

export class InspectionFacility {
    inspectionID : number;
    facilityID : number;
    applicationID: number;

    constructor(facilityId, applicationId){
        this.facilityID = facilityId;
        this.applicationID = applicationId;
    }
}

export class InspectionAssignment {
    inspectionID : number;
    userID: number;
    dueDate: Date;
    primary: boolean;  
    startDate: Date; 
    assignmentType: string;
    actualStartDate: Date;
    actualDueDate: Date;

    constructor(userId, isPrimary, dueDate){
        this.userID = userId;
        this.primary = isPrimary;
        this.dueDate = dueDate;
    }
}

export class ScreeningChecklistInstance {
    checklistValueID: number;
    checklistValue: CheckListValueModel;
    checklistID: number;
    inspectionID: number;
    checklist: ChecklistModel;
    id: number;
    screenerResponseValue: CheckListValueModel;
    screenerResponseValueID: number;

    constructor(checklist: ChecklistModel){
        this.checklist= checklist;
        this.checklistValue = new CheckListValueModel();
    }
}

export class Inspection {
    id: number;
    inspectionNumber: string;
    typeID: number;
    statusID: number;
    createdBy: number;
    previousInspectionID: number;
    type: InspectionType;
    status: InspectionStatus;
    userDto: UserDto;
    previousInspection: Inspection;
    inspectionFacility: Array<InspectionFacility>;
    inspectionAssignments: Array<InspectionAssignment>;
    documents: Array<DocumentDetail>;
    inspectionResults: Array<any>;
    facilityInfo: any;
    previousInspectionNumber: string;
    letterNumber: string;
    letterGenerationDate: Date;
    investigationTypeID: number;
    investigationType: InvestigationType;
    purposeOfApplication: string;
    inspectionAbroadFacility: Array<InspectionAbroadFacility>;
    inspectionPayment: Array<PaymentInfo>;
    productionInfo: ProductionInfo;
    screenerResponseSummary: string;
    screeningChecklists: Array<ScreeningChecklistInstance>;
    checklistComplete: boolean;
    reasonID: number;
    reason: InspectionReason;
    appliedFees: Array<InspectionFee>;
    differentProductionLine: boolean;
    previousGMPCertificateNumber : string;
    isLegacyData: boolean;
    inspectionCapas: Array<InspectionCapa> = [];
    previousGMPIssuingCountryID: number;
    previousGMPIssuingCountry: Country;

    constructor(insAssiggnments, insFacility, insAbroadFacility, purpose = null ){
        this.inspectionFacility = insFacility     
        this.inspectionAbroadFacility = insAbroadFacility;
        this.inspectionAssignments = insAssiggnments;
        this.purposeOfApplication = purpose;
    }
}

export class InspectionResult {
    documentID: number;
    inspectionIdentifier: string;
    odkResponseUUID: string;
    odkFormID: string;
    odkFormUploadDate: string;
    statusName: string;
    inspectionResultDocuments : Array<InspectionResultDocument>;
    document: any;
    fileName: string;
    createdDate: string;
    uploadedTime: string;
    taskForceReportDocument: InspectionResultDocument;
}

export class InspectionResultDocument {
    inspectionDocumentID: number;
    inspectionDocument: DocumentDetail;
    fileName: string;
}

export class InspectionView{
    id: number;
    inspectionNumber: string;
    typeID: number;
    statusID: number;
    createdBy: number;
    previousInspectionID: number;
    inspectionStatusCode: string;
    inspectionStatusName : string;
    inspectionTypeCode : string;
    inspectionTypeName : string;
    facilityID : number;
    facilityName : string;
    assignedUser : string;
    assignedUserID: number;
    dueDate: string;
    facilityTypeName: string;
    productType: string;
    localAgentName: string;
    manufacturerName: string;
    manufacturerCountry: string;
    siteAddress: string;
    supplierName: string;
    assignmentStartDate: string;
}

export class AssignInspection {
    inspectionID: number;
    assignees: Assignee[];
    dueDate: string;
    startDate: string;
    assignmentType: string;
 
    constructor(appID: number, assignees: Assignee[], dueDate: string, startDate: string, type: string) {
       this.inspectionID = appID;
       this.assignees = assignees;
       this.dueDate = dueDate;
       this.startDate = startDate;
       this.assignmentType = type;
    }
 }

 export class AbroadFacility {
    approvedAgentID : number;
    approvedAgent: Agent;
    localAgentName : string;
    localAgentPhone : string;
    localAgentEmail : string;
    manufacturerContactName: string;
    manufacturerContactPhone : string;
    manufacturerContactEmail : string;
    manufacturer: Manufacturer;

    qualityAssuranceName : string;
    qualityAssurancePhone : string;
    qualityAssuranceEmail : string;
    // quality control
    qualityControlName : string;
    qualityControlPhone : string;
    qualityControlEmail : string;
    // product manager
    productManagerName : string;
    productManagerPhone : string;
    productManagerEmail : string;
    // international marketing
    internationalMarketingName : string;
    internationalMarketingPhone : string;
    internationalMarketingEmail : string;
    // regularity affair
    regularityAffairName : string;
    regularityAffairPhone : string;
    regularityAffairEmail : string;

    ownerName: string;
    ownerPhone: string;
    ownerEmail: string;

    constructor(incomingObject: any){
        this.localAgentName = incomingObject['localAgentName'];
        this.localAgentPhone = incomingObject["localAgentPhone"];
        this.localAgentEmail = incomingObject["localAgentEmail"];
        this.manufacturerContactName = incomingObject["manufacturerContactName"];
        this.manufacturerContactPhone = incomingObject["manufacturerContactPhone"];
        this.manufacturerContactEmail = incomingObject["manufacturerContactEmail"];
        this.approvedAgentID = incomingObject["approvedAgentID"];
        this.manufacturer = incomingObject["manufacturer"];
    }
 }

 export class Manufacturer {
    name: string;
    countryID: number;
    siteAddress: string;
    email: string;
    website: string;
    country: Country;

    constructor(incomingObject: any){
        this.name = incomingObject["name"];
        this.countryID = incomingObject["countryID"];
        this.siteAddress = incomingObject["siteAddress"];
        this.email = incomingObject["email"];
        this.website = incomingObject["website"];
    }
}


 export class InspectionAbroadFacility{
    abroadFacilityID: number;
    inspectionID: number;
    abroadFacility: AbroadFacility;
    applicantTypeID: number;
    applicantType: ApplicantType;
    applicantCountryID: number;
    applicantName: string;
    applicantPhone: string;
    applicantEmail: string;
    applicantStreet: string;
    applicantCountry: any;

    constructor(abroadFacility: AbroadFacility){
        this.abroadFacility = abroadFacility;
    }
 }

 export class ProductionInfo {
    approvalMethodID : number;
    agencyID : number;
    productBrandName : string;
    productGenericName : string;
    countryID : number;
    country: any;
    approvalMethod: ApprovalMethod;
    agency: Agency;
    prodInfoDosageForms: Array<ProdInfoDosageForm>;
    productDetails: Array<GmpProductDetail>;

    constructor(incomingObject: any){
        this.approvalMethodID = incomingObject["approvalMethodID"];
        this.agencyID = incomingObject["agencyID"];
        this.productBrandName = incomingObject["productBrandName"];
        this.productGenericName = incomingObject["productGenericName"];
        this.prodInfoDosageForms = incomingObject["prodInfoDosageForms"];
        this.countryID = incomingObject["countryID"];
    }
 }

 export class ProdInfoDosageForm {
    productionInfoID: number;
    dosageFormID: number;
    dosageForm: DosageForm;
 }

 export class ProductCategory {
    id: number;
    name : string;
 }

 export class AttachmentList {
    category: number;
    agency: number;
    applicantType: number;
 }

 export class ProductionLine{
    id: number;
    name: string;
    specificManufacturingOperation: SpecificManufacturingOperation;
    group: string;
    specificManufacturingOperationID: number;
    isActive: boolean;
    oldProductCategory: ProductCategory; // for backward compatability
 }

 export class ApprovalMethod {
    id: number;
    name: string;
    description: string;
 }

 export class Agency {
    id: number;
    name : string;
    agencyCode: string;
 }

 export class DosageForm {
    name : string;
 }

 export class InspectionFee {
     id: number;
     type: string;
     code: string;
     description: string;
     isSra : boolean;
     hasMultipleFacility: boolean;
     amount: number;
     siteAddress: string;
 }

export class Agent {
    id: number;
    email: string;
    phone: string;
    name: string;
}

export class InspectionCapa {
    id: number;
    inspectionID: number;
    capaDueDate: Date;
    implementationReportDueDate: Date;
    capaDocID: number;
    implementationReportDocID: number;
}

export class ManufacturingOperation {
    id: number;
    name : string;
    specificManufacturingOperations: SpecificManufacturingOperation[] = [];
    productCategory: ProductCategory;
}

export class SpecificManufacturingOperation {
    id: number;
    name : string;
    manufacturingOperation: ManufacturingOperation;
    manufacturingOperationID: number;
}

export class QualityControlTest {
    id: number;
    name: string;
}

export class Packaging {
    id: number;
    name: string;
    manufacturingOperation: string;
}

export class GmpProductDetail {
    productionLine: ProductionLine;
    packagingType: string[];
    hasBatchCertification: boolean;
    qualityControlTests: QualityControlTest[];
    othersProductCategory: string;
    othersProductionLine: string;
    packaging: Packaging;
    othersPackaging: string;
    offsiteFacilities: OffsiteFacility[] = [];

    constructor(formData: any) {
        this.hasBatchCertification = formData.batchCertification ?? false;
        this.packagingType = formData.packagingTypes?.map(p => p.name) ?? [];
        if(formData.manufacturingOperation?.name == "1.2 Sterile Products" && !this.packagingType.includes('Primary')) {
            this.packagingType.push('Primary');
        }
        this.qualityControlTests = formData.qualityControlTests;
        this.productionLine = formData.productionLine;
        this.packaging = this.packagingType.includes('Primary') ? formData.packaging: null;
    }
}

export class OffsiteFacility {
    name: string;
    address: string;
    streetNumber: string;
    phone: string;
    email: string;
    website: string;
    facilityType: string;
    packagingType: string[] = [];
    packaging: Packaging;
    qualityControlTests: QualityControlTest[] = [];
    productionLines: ProductionLine[] = [];
    identifier: number;

    constructor(formData: any, facilityType: string) {
        this.name = formData.name;
        this.address = formData.address;
        this.streetNumber = formData.streetNumber;
        this.phone = formData.phone;
        this.email = formData.email;
        this.website = formData.website;
        this.facilityType = facilityType;
        this.packagingType = formData.offsitePackagingTypes?.map(p => p.name) ?? [];
        this.packaging = this.packagingType.includes('Primary') ? formData.offsitePackaging: null;
        this.qualityControlTests = formData.offsiteQualityControlTests;
    }
}

export class OffsiteFacilityTypes {
    public static PACKAGING: string = 'Packaging';
    public static QUALITY_CONTROL_TESTING: string = 'QualityControlTesting';
    public static BATCH_CERTIFICATION: string = 'BatchCertification';
}

export class InspectionStatuses {
   public static REQUESTED_CODE: string = 'RQST';
   public static INSPECTED_CODE: string = 'RINP';
   public static INSPECTION_FAILED_CODE: string = 'RINF';
   public static RECOMMEND_FOR_APPROVAL_CODE: string = 'RAP';
   public static RECOMMEND_FOR_REJECTION_CODE: string = 'RCNC';
   public static RETURN_TO_INSPECTOR_CODE: string = 'RTI';
   public static RETURN_TO_INSPECTION_TEAM_LEADER_CODE: string = 'RTITL';
   public static APPROVAL_LETTER_GENERATED_CODE: string = 'ALEG';
   public static PARTIAL_APPROVAL_LETTER_GENERATED_CODE: string = 'PALG';
   public static PRODUCT_RECALLED_CODE: string = 'PRC';
   public static LICENSE_CANCELLED_CODE: string = 'LCC';
   public static LICENSE_SUSPENDED_CODE: string = 'LCS';
   public static WARNING_GIVEN_CODE: string = 'WAG';
   public static CAPA_PLAN_SUBMITTED: string = 'CAPS';
   public static FORWARDED_FOR_FOLLOW_UP_INSPECTION: string = 'FFI';
   public static RETURN_TO_APPLICANT: string = 'RTA';
   public static ASSIGNED_TO_INSPECTOR: string = 'ASDI';
   public static SCREENING_PASSED: string = 'SCP';
   public static SCREENING_FAILED: string = 'SCF';
   public static FEE_ATTACHED: string = 'FATCH';
   public static RECOMMEND_FOR_PAYMENT_APPROVAL: string = 'RPA';
   public static RECOMMEND_FOR_PAYMENT_FAILURE: string = 'RPF';
   public static NON_COMPLIANCE_LETTER_GENERATED: string = 'NCLG';
   public static APPROVAL_LETTER_GENERATED_WITH_CAPA: string = 'ALGC';
   public static WITHDRAWN: string = 'WITH'
   public static ASSIGNED_TO_GMP_OFFICER: string = 'ASGI';
   public static FINAL_FILE_SUBMITTED_CODE : string = 'FFS';
   public static APPROVED_FOR_INSPECTION_CODE : string = 'AFI';
   public static RETURNED_TO_FILE_SUBMISSION_CODE: string = 'RTFS';
   public static UNDO_WITHDRAW: string = 'UNDO_WITHDRAW';
   public static REJECTED: string = 'REJ';
   public static GMP_SUSPENDED: string = 'GMS';
   public static GMP_CANCELLED: string = 'GMC';
   public static GMP_REVOKED: string = 'GRVK';
   public static GMP_VOID: string = "VOID";
   public static LEGACY_DATA_EDITED = "LDE";
   public static RECOMMEND_FOR_SCREENING_PASS : string = 'RCPY';
   public static RECOMMEND_FOR_SCREENING_FAIL : string = 'RCRA';
   public static FINAL_PAYMENT_REQUESTED : string = 'FPR';
   public static FINAL_PAYMENT_ATTACHED : string = 'FPA';
   public static FINAL_PAYMENT_RETURNED :string = 'FPRT';
   
   public static CAPA_PLAN_REQUESTED : string = "CAPREQ";
   public static CAPA_PLAN_REJECTED : string = "CAPREJ";
   public static IMPLEMENTATION_REPORT_REQUESTED : string = "IMRREQ";
   public static IMPLEMENTATION_REPORT_SUBMITTED : string = "IMRS";
   public static IMPLEMENTATION_REPORT_REJECTED : string = "IMRREJ";

   public static PAYMENT_APPROVED: string = "PAYA";
   public static PAYMENT_RETURNED_TO_COORDINATOR: string = "PAYRC";
   public static ASSIGNED_TO_TASK_FORCE: string = "ATF";
   public static PASSED_TASK_FORCE_ASSESMENT: string = "PTFA";
   public static FAILED_TASK_FORCE_ASSESMENT: string = "FTFA";

   public static FIR_REQUESTED_BEFORE_INSPECTION: string = "FIRRBI";
   public static FIR_REQUESTED_AFTER_INSPECTION: string = "FIRRAI";
   public static FI_SUBMITTED_BEFORE_INSPECTION: string = "FISBI";
   public static FI_SUBMITTED_AFTER_INSPECTION: string = "FISAI";

   public static RETURNED_TO_GMP_OFFICER: string = "RTIN";
   public static CAPA_PLAN_RECOMMEND: string = "RCAP";
   public static SUBMIT_FOR_APPROVAL: string = "SAPR";
 
public static TENTATIVE_PLAN_APPROVED: string = "TPAP";
public static TENTATIVE_PLAN_RETURNED: string = "TPRT";
public static TENTATIVE_PLAN_SHARED: string = "TPSH";
public static AGREEMENT_NOTIFIED: string = "RDNT";
public static DISAGREEMENT_NOTIFIED : string= "URNT";
public static INSPECTION_REPORT_SUBMITED : string= "INRS";
public static RETURN_REPORT_TO_INSPECTOR: string = "RRTI";
public static APPLICATION_CLOSED: string = "APCL";
public static REVIEW_MINUTE_SHARED : string= "RMSH";
public static TASK_FORCE_REVIEW_REPORT_UPDATED: string = "TFRU";
public static REQUEST_FOR_REJECTION: string = "RJRQ";
public static CAPA_PLAN_AND_IMPLEMENTATION_EVIDENCE_SUBMITTED: string = "CIES";
public static PAYMENT_RETURNED_TO_APPLICANT: string = "PRTA";

public static ASSIGNED_TO_INSPECTOR_FOR_TENTATIVE_PLAN: string = "ASTP";
public static TENTATIVE_PLAN_SUBMIT: string = "TPSB";
public static ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION: string  = "AIAI";
public static FINAL_PAYMENT_APPROVED: string  = "FPAP";
public static RECOMMEND_FOR_APPROVAL_AFTER_INSPECTION: string = "RAAI";
public static RECOMMEND_FOR_CORRECTION: string = "RFCR"; 
public static RETURN_TO_INSPECTOR_AFTER_INSPECTION: string = "RIAI";
public static RETURN_FOR_CORRECTION: string  = "RTCR";
public static RETURNED_TO_APPLICANT_TO_COMPLETE_APPLICATION: string = "RACA";
public static PAYMENT_REQUEST_LETTER_GENERATED: string = "PRLG";
public static PARTIAL_APPROVAL_RECOMMENDED: string = "PARC";
public static PARTIAL_APPROVAL_SUBMITTED: string = "PASB";

public static RECOMMENDED_FOR_SITE_INSPECTION: string = "RSIN";
public static SITE_INSPECTION_REPORT_SUBMITTED: string = "SIRS";
public static  RETURNED_TO_DESK_HEAD_FOR_REVIEW: string = "RDHR";

public static ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE ="ASIE";
public static RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE ="RAIE";
public static RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE ="RRIE";
public static RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE ="RPIE";
public static RECOMMENDED_FOR_CORRECTION_AFTER_IMPLEMENTATION_EVIDENCE: string = "RCIE"; 
} 

export class InspectionTypes {
    public static POST_LICENSING_INSPECTION: string = 'PLI';
    public static NEW_LOCAL_GMP_INSPECTION: string = 'NLGI';
    public static LOCAL_GMP_RENEWAL_INSPECTION: string = 'LGRI';
    public static INVESTIGATION_INSPECTION: string = 'INVI';
    public static INFORMAL_MARKET_INSPECTION: string = 'IMI';
    public static NEW_ABROAD_CGMP_INSPECTION: string = 'NACI';
    public static NEW_ABROAD_CGMP_INSPECTION_WAIVER: string = 'NACIW';
    public static ABROAD_CGMP_RENEWAL_INSPECTION: string = 'ACRI';
    public static ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL: string = 'ACIWR';
    public static ABROAD_CGMP_LINE_ADDITION_INSPECTION: string = 'ACLAI';

    public static codeToName(code){
        switch(code){
            case InspectionTypes.POST_LICENSING_INSPECTION:
                return "Post Licensing";
            case InspectionTypes.NEW_LOCAL_GMP_INSPECTION:
                return "New Local GMP";
            case InspectionTypes.LOCAL_GMP_RENEWAL_INSPECTION:
                return "Local GMP Renewal";
            case InspectionTypes.INVESTIGATION_INSPECTION:
                return "Investigation";
            case InspectionTypes.INFORMAL_MARKET_INSPECTION:
                return "Informal Market";
            case InspectionTypes.NEW_ABROAD_CGMP_INSPECTION:
                return "New Abroad CGMP";
            case InspectionTypes.NEW_ABROAD_CGMP_INSPECTION_WAIVER:
                return "New Abroad CGMP Waiver";
            case InspectionTypes.ABROAD_CGMP_RENEWAL_INSPECTION:
                return "Abroad CGMP Renewal";
            case InspectionTypes.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL:
                return "Abroad CGMP Waiver Renewal";
            case InspectionTypes.ABROAD_CGMP_LINE_ADDITION_INSPECTION:
                return  "Abroad CGMP Line Addition";
        }
    }
}